import React, { useEffect, useState } from "react";
import { axiosInstance } from "../../axiosInstance";
import "./SharePublic.css";
import { FaPhone } from "react-icons/fa6";
import { MdEmail } from "react-icons/md";
import { BsArrowLeft } from "react-icons/bs";
import { FaWhatsapp } from "react-icons/fa";
import { Link, useParams } from "react-router-dom";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import Modal from "@mui/material/Modal";
import { IoIosClose } from "react-icons/io";
import verifyedProfile from "../../assets/images/verifyed-profile-removebg-preview.png";
import verifiedMatch from "../../assets/images/verified-match.png";
import { ToastContainer, toast } from "react-toastify";
import Preloader from "../../Components/Loader/Loader";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: {
    xs: "90%",
    sm: 400,
    md: 500,
  },
  bgcolor: "background.paper",
  boxShadow: 24,
  borderRadius: "10px",
  p: 4,
};
export function SharePublic() {
  const [profiles, setProfiles] = useState([]);
  const [agencyName, setagencyName] = useState();
  const [agentName, setagentName] = useState();
  const [agentNameUrl, setagentNameUrl] = useState();
  const [agentMobile, setagentMobile] = useState();
  const [agentEmail, setagentEmail] = useState();
  const [planType, setPlanType] = useState();
  // const [shared, setShared] = useState(false);
  const [about, setAbout] = useState();
  const [terms, setTerms] = useState();
  // modal state
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const [showModal, setShowModal] = useState(false);
  const [selectedProfileId, setSelectedProfileId] = useState(null);
  const [values, setValues] = useState({
    user_name: "",
    mobile_number: "",
  });

  const [loading, setLoading] = useState(false);

  // const planType = localStorage.getItem("PlanType"); // no JSON.parse
  // console.log(planType);

  console.log(profiles);

  const { publicToken, name } = useParams();
  console.log("params", publicToken);
  //  for disable right click
  // useEffect(() => {
  //   const handleRightClick = (e) => {
  //     e.preventDefault();
  //   };

  //   document.addEventListener("contextmenu", handleRightClick);

  //   return () => {
  //     document.removeEventListener("contextmenu", handleRightClick);
  //   };
  // }, []);

  // async function handlePublicProfile() {
  //   // const public_token = localStorage.getItem("public_token");
  //   try {
  //     const response = await axiosInstance.get(
  //       `share-biodata-list/${publicToken}`
  //     );
  //     setagencyName(response.data.data.agency_name);
  //     setagentMobile(response.data.data.mobile);
  //     setagentEmail(response.data.data.email);
  //     setagentName(response.data.data.full_name);
  //     setagentNameUrl(response.data.data.first_name);
  //     setAbout(response.data.data.about);
  //     setTerms(response.data.data.terms_condition);

  //     const biodataSet = response.data.data.biodata_set;

  //     // Flatten all images from all biodata entries
  //     // const allImages = biodataSet.flatMap((biodata) => biodata.images || []);
  //     // setProfiles(allImages);
  //     const firstImages = biodataSet
  //       .map((biodata) => biodata.images?.[0]) // get only the first image
  //       .filter(Boolean); // remove undefined/null entries
  //     setProfiles(firstImages);
  //   } catch (error) {
  //     console.log("Error while fetching profiles", error);
  //   }
  // }

  const handlePublicProfile = async () => {
    try {
      const response = await axiosInstance.get(
        `share-biodata-list/${publicToken}`
      );
      const data = response.data.data;

      setPlanType(data.plan);
      setagencyName(data.agency_name);
      setagentMobile(data.mobile);
      setagentEmail(data.email);
      setagentName(data.full_name);
      setagentNameUrl(data.first_name);
      setAbout(data.about);
      setTerms(data.terms_condition);
      setProfiles(data.biodata_set); // Keep full biodata objects
    } catch (error) {
      console.log("Error while fetching profiles", error);
    }
  };

  useEffect(() => {
    handlePublicProfile();
  }, []);

  function shareWhatsapp() {
    const currentUrl = window.location.href;
    const shareText = `Greetings from ${agencyName}\n\nI'm excited to share a few profiles that closely match your preferences.\n\nCheck them out: ${currentUrl}`;
    const whatsappUrl = `https://wa.me/?text=${encodeURIComponent(shareText)}`;

    window.open(whatsappUrl, "_blank");
    // setShared(true); // Hide the button after opening the link
  }
  const token = localStorage.getItem("token");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setValues((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleModalClose = () => {
    setShowModal(false);
    setSelectedProfileId(null);
    setValues({ user_name: "", mobile_number: "" }); // reset on close
  };

  const handleShowModal = (profileId) => {
    setSelectedProfileId(profileId);
    setShowModal(true);
  };

  const handleSubmit = async () => {
    if (!values.user_name || !values.mobile_number) {
      toast.error("Both fields are required.");
      return;
    }
    setLoading(true);

    try {
      const payload = {
        agent_id: publicToken, // from useParams
        user_name: values.user_name,
        mobile_number: values.mobile_number,
        requested_profile_id: selectedProfileId,
      };

      const response = await axiosInstance.post("/onboard-request", payload);

      // ✅ Check if status is true
      if (response.data.status === true) {
        toast.success("Request submitted successfully!");
        setLoading(false);
        handleModalClose(); // ✅ close modal
      } else {
        toast.error(response.data.message || "Submission failed.");
        setLoading(false);
      }
    } catch (error) {
      console.error("Error sending request:", error);
      toast.error("Failed to submit request.");
      setLoading(false);
    }
  };

  return (
    <>
      <ToastContainer />
      {loading && <Preloader />}
      <div className="sharePublicBg">
        <div className="container">
          <div className="share-header">
            <div className="whatsapp-container">
              <div className="d-flex">
                {token ? (
                  <Link
                    to="/view-more"
                    style={{
                      color: "#2B171B",
                      marginTop: "15px",
                      marginRight: "10px",
                    }}
                  >
                    <span>
                      <BsArrowLeft />
                    </span>
                  </Link>
                ) : (
                  ""
                )}

                <div className="publicAgency-name">
                  <span>{(agencyName==="null" || agencyName ===null || agencyName==="")?"Nathicharami-Agency":agencyName}</span>
                  {/* <span>{agencyName ? agencyName : "Nathicharami-Agency"}</span> */}
                  {planType === "Premium" && (
                    <img
                      src={verifiedMatch}
                      alt="Verified Badge"
                      className="badge-inline"
                    />
                  )}
                </div>
              </div>
              <div>
                {token ? (
                  <button className="btnShare" onClick={shareWhatsapp}>
                    <span>
                      <FaWhatsapp />
                    </span>
                  </button>
                ) : (
                  ""
                )}
              </div>
            </div>
            <div className="sharePublic-desc">
              {about &&
              about.trim().toLowerCase() !== "null" &&
              about.trim().toLowerCase() !== "undefined"
                ? about
                : "Hello! I’m a Matchmaker Agent at Nathicharami Matrimony, passionate about helping individuals and families find the right life partner. I provide personalized support—understanding your preferences, shortlisting suitable matches, and guiding you through every step of the journey."}
            </div>
          </div>
          <div className="profile-text">Profiles uploaded by {agentName}</div>
          {/* images section */}

          {/* <div className="images-part">
          {profiles.map((profile) => (
            <div className="image-section" key={profile.id}>
              <div className="imageContainer">
                {planType === "Premium" && (
                  <div className="badge-top-right">
                    <img src={verifyedProfile} alt="Verified Badge" />
                  </div>
                )}
                <img
                  src={profile.image}
                  alt="Profile"
                  className={profile.is_blur === true ? "blur-image" : ""}
                />

                <div className="overlay">
                  <div>
                    <div className="contactAgent">Contact Agent</div>
                    <div className="contactNumber">
                      <FaPhone /> &nbsp; {agentMobile}
                    </div>
                    <div className="request-rais">
                      <button
                        className="small-request-btn"
                        onClick={() => handleShowModal(profile.id)}
                      >
                        Request
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div> */}

          <div className="images-part">
            {profiles.map((biodata) => {
              const firstImage = biodata.images?.[0]; // ✅ only first image

              if (!firstImage) return null;

              return (
                <div className="image-section" key={biodata.id}>
                  <div className="imageContainer">
                    {/* {planType === "Premium" && (
                      <div className="badge-top-right">
                        <img src={verifyedProfile} alt="Verified Badge" />
                      </div>
                    )} */}

                    <img
                      src={firstImage.image}
                      alt="Profile"
                      className={firstImage.is_blur ? "blur-image" : ""}
                    />

                    <div className="overlay">
                      <div>
                        <div className="contactAgent">Contact Agent</div>
                        <div className="contactNumber">
                          <FaPhone /> &nbsp; {agentMobile}
                        </div>
                        <div className="request-rais">
                          <button
                            className="small-request-btn"
                            onClick={() => handleShowModal(biodata.id)}
                          >
                            Request
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>

          {/* footer section */}
          <div className="footer-agencyName mb-2">{agencyName}</div>
          <div className="footer-grid">
            <div className="footer-contactContainer">
              <div>
                <FaPhone /> &nbsp;{agentMobile}
              </div>
              <div>
                <MdEmail /> &nbsp;{agentEmail}
              </div>
            </div>
            <div className="footerGrid-list">
              <Button onClick={handleOpen} sx={{ textTransform: "none" }}>
                Terms & Conditions
              </Button>
              {/* <span>Refund Policy</span>
        <span>Privacy Policy</span>
        <span>Pricing Policy</span> */}
            </div>
          </div>

          {/* modal of terms and conditions */}
          <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style}>
              <div
                className="fs-4 "
                style={{
                  position: "absolute",
                  top: 2,
                  right: 8,

                  cursor: "pointer",
                  zIndex: 1,
                }}
                onClick={handleClose}
              >
                <IoIosClose size={28} />
              </div>
              <Typography id="modal-modal-title" variant="h6" component="h2">
                Terms & Conditions :
              </Typography>
              <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                {terms}
              </Typography>
            </Box>
          </Modal>

          {/* MUI Modal */}
          <Modal open={showModal} onClose={handleModalClose}>
            <Box
              sx={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                width: {
                  xs: "90%", // extra-small screens
                  sm: 400, // small screens
                  md: 550, // medium and up
                },
                maxHeight: "90vh",
                overflowY: "auto",
                bgcolor: "background.paper",
                borderRadius: "8px",
                boxShadow: 24,
                p: { xs: 2, sm: 4 },
              }}
            >
              <Typography variant="h6" mb={2}>
                Confirm Request
              </Typography>

              <TextField
                fullWidth
                label="User Name"
                name="user_name"
                value={values.user_name}
                onChange={handleChange}
                required
                sx={{ mb: 2 }}
              />

              <TextField
                fullWidth
                label="Mobile Number"
                name="mobile_number"
                value={values.mobile_number}
                onChange={handleChange}
                required
                sx={{ mb: 2 }}
              />

              <Box mt={3} display="flex" justifyContent="flex-end" gap={2}>
                <Button variant="outlined" onClick={handleModalClose}>
                  Cancel
                </Button>
                <Button
                  variant="contained"
                  sx={{ backgroundColor: "#F24464" }}
                  onClick={handleSubmit}
                >
                  Submit
                </Button>
              </Box>
            </Box>
          </Modal>
        </div>
      </div>
    </>
  );
}
